import { useContext } from "react";
import { SupportChatContext } from "../context/SupportChatContext/ChatContext";

const useChat = () => {
  return useContext(SupportChatContext);
};

export default useChat;
